module.exports = __webpack_public_path__ + "img/icon_arrow_down_yellow.225011bd.svg";